'use client';

import { Link } from 'react-router-dom';

function AddBtn({ item, title }) {
  return (
    <Link
      type='button'
      to={`/${item}/add`}
      className='btn btn-light btn-sm'
      style={{ fontSize: '12px', padding: '6px 12px' }}
    >
      <i className='fa fa-plus me-1' style={{ fontSize: '11px' }} />
      Add {title}
    </Link>
  );
}

export default AddBtn;
